'use client';

import { CalendarIcon } from 'lucide-react';
import * as React from 'react';

import { Button } from '@/components/shadcn/button';
import { Calendar as ShadcnCalendar } from '@/components/shadcn/calendar';
import { Input } from '@/components/shadcn/input';
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from '@/components/shadcn/popover';

function formatDate(date: Date | undefined) {
    if (!date) {
        return '';
    }

    return date.toLocaleDateString('en-US', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    });
}

function isValidDate(date: Date | undefined) {
    if (!date) {
        return false;
    }
    return !isNaN(date.getTime());
}

export function Calendar({
    date,
    setDate,
}: {
    date: Date | undefined;
    setDate: (date: Date | undefined) => void;
}) {
    const [open, setOpen] = React.useState(false);
    // const [date, setDate] = React.useState<Date | undefined>(new Date());
    const [month, setMonth] = React.useState<Date | undefined>(date);
    const [value, setValue] = React.useState(formatDate(date));

    return (
        <div className="flex flex-col gap-3">
            <div className="relative flex gap-2">
                <Popover open={open} onOpenChange={setOpen}>
                    <PopoverTrigger asChild>
                        <div>
                            <Button
                                id="date-picker"
                                variant="ghost"
                                className="absolute top-1/2 left-2 size-6 -translate-y-1/2"
                            >
                                <CalendarIcon className="size-3.5" />
                                <span className="sr-only">Select date</span>
                            </Button>
                            <Input
                                id="date"
                                value={value}
                                placeholder="Jun 01, 2025"
                                className="bg-white pl-10 cursor-pointer w-[160px] rounded-[12px] max-md:text-[14px] text-center"
                                readOnly
                                // onChange={(e) => {
                                //     const date = new Date(e.target.value);
                                //     setValue(e.target.value);
                                //     if (isValidDate(date)) {
                                //         setDate(date);
                                //         setMonth(date);
                                //     }
                                // }}
                                // onKeyDown={(e) => {
                                //     if (e.key === 'ArrowDown') {
                                //         e.preventDefault();
                                //         setOpen(true);
                                //     }
                                // }}
                            />
                        </div>
                    </PopoverTrigger>
                    <PopoverContent
                        className="w-auto overflow-hidden p-0"
                        align="end"
                        alignOffset={-8}
                        sideOffset={10}
                    >
                        <ShadcnCalendar
                            mode="single"
                            selected={date}
                            captionLayout="dropdown"
                            month={month}
                            onMonthChange={setMonth}
                            onSelect={(date) => {
                                setDate(date);
                                setValue(formatDate(date));
                                setOpen(false);
                            }}
                        />
                    </PopoverContent>
                </Popover>
            </div>
        </div>
    );
}
